import React from "react";

export interface UseCircleBackgroundRefProps {
  color: string;
  total: number;
  radius: number;
  distance: number;
}

export default function useCircleBackgroundRef(
  props: UseCircleBackgroundRefProps
): (ref: HTMLDivElement) => void {
  const { color, total, radius, distance } = props;

  return React.useCallback(
    (ref: HTMLDivElement) => {
      if (!ref) {
        return;
      }
      const svgString = createCirclesSvg(color, total, radius, distance);
      const imageBg = `url(data:image/svg+xml;base64,${window.btoa(
        svgString
      )})`;
      ref.style.backgroundImage = imageBg;
    },
    [color, distance, radius, total]
  );
}

function createCirclesSvg(
  color: string,
  total: number,
  radius: number,
  distance: number
) {
  const circles: string[] = [];
  let curRadius = radius;
  for (let i = 0; i < total; i++) {
    circles.push(
      `<circle cx="50%" cy="50%" r="${curRadius}" stroke="${color}" fill="transparent"/>`
    );
    curRadius += distance;
  }

  return `
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="100% 100%">
    ${circles.join("")}
  </svg>
`;
}
